// 微信直销商城首页
<template>
    <div>
        <Search
            placeholder="车品查找"
            v-model="keyword"
            show-action
            @search="onSearch"
            @cancel="onCancel"/>
        <Loading vertical v-if="loading"/>
        <div v-for="itm in clsdata" :key="itm.id" class="list">
            <Cell :title="itm.name" :is-link="itm.hasmore" arrow-direction @click="gocls(itm)"/>
            <Grid :column-num="4" square>
                <GridItem
                    v-for="item in itm.children"
                    :key="item.id"
                    :icon="item.img_url"
                    :text="item.name"
                    @click="selCatalogItems(item)">
                </GridItem>
            </Grid> 
        </div>
    </div>
</template>

<script>
import { Search, Grid, GridItem, Cell, Loading } from 'vant'
import { ClsApi } from '@/api/market'
import { refreshCars } from '@/utils/localutils'
import { toErrorPage } from '@/utils/usePage'
// eslint-disable-next-line no-unused-vars
// import vConsole from '@/utils/vconsole'

export default {
    data() {
        return {
            keyword: '',
            clsdata: [],
            loading: false
        }
    },
    components: {
        Cell,
        Search,
        Grid,
        GridItem,
        Loading
    },
    methods: {
        getData() {
            var that = this
            this.loading = true
            this.axios.get(ClsApi, {params: {issupply: true}}).then((ret) => {
                console.log('in')
                that.loading = false
                console.log(ret)
                if(ret.hasOwnProperty("flag")) { 
                    toErrorPage(that,'',ret.info,null)
                } else {
                    let cls = ret.filter((it) => it.parent === null)
                    cls.forEach((it) => {
                        it.hasmore = false
                        let tmp = ret.filter((itm) => itm.parent === it.id)
                        if (tmp.length > 8) {
                            tmp = tmp.slice(0,8)
                            it.hasmore = true
                        }
                        it.children = tmp
                    })
                    that.clsdata = cls                    
                }})
        },
        selCatalogItems(item) {
            const data = {
                cls1: item.id
            }
            this.$router.push({
                name: 'nt/listitems',
                query: JSON.stringify(data)
            })
        },
        onSearch() {
            if (this.keyword && this.keyword.length > 0) {
                const data = {
                    prd_name: this.keyword
                }
                this.$router.push({
                    name: 'result',
                    query: JSON.stringify(data)
                })
            }
        },
        onCancel() {
            this.keyword = ''
        },
        gocls(data) {
            console.log(data)
            this.$router.push(`/catalogitems/${data.id}`)
        }
    },
    mounted() {
        this.getData()
        // this.setCarData()
        refreshCars()
    }
}
</script>